import React from "react";
import ReactTable from "react-table-6";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { newNpropValue } from "../../../redux/actions/devisActions";
import { numberToFormat } from "../../Utils";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Save as SaveIcon } from "@material-ui/icons";

class DevisConTable2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nbrHeures: this.props.devisTab.nbrHeures,
      ht: this.props.devisTab.ht,
      approved: false
    };
  }

  componentDidMount() {
    this.setState((prevState) => ({
      ht: [
        prevState.nbrHeures[0] * this.props.tauxh,
        prevState.nbrHeures[6] * this.props.tauxh,
      ],
    }));
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.dossierValue !== prevProps.dossierValue ||
      this.props.nprop !== prevProps.nprop
    ) {
      this.setState({
        nbrHeures: this.props.devisTab.nbrHeures,
        ht: this.props.devisTab.ht,
      });
    }
  }

  handleChange(event, index) {
    const rawValue = event.target.value;
    const normalizedValue = rawValue.replace(",", ".");
    const isValidNumericInput = /^(\d+([.]\d*)?|[.]\d+)?$/.test(normalizedValue);

    if (!isValidNumericInput) {
      return;
    }

    let nbrHeures = [...this.state.nbrHeures];
    if (index < 6) {
      nbrHeures[index - 1] = normalizedValue;
    } else if (index < 11) {
      nbrHeures[index - 2] = normalizedValue;
    }
    this.setState({ nbrHeures });
  }

  preventNonNumericKeys(event) {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
      ".",
      ",",
    ];
    if (allowedKeys.includes(event.key)) return;
    if (/^\d$/.test(event.key)) return;
    event.preventDefault();
  }

  heureAvantProjet() {
    const totalHeures = this.state.nbrHeures
      .slice(0, 5)
      .reduce((total, heures) => total + Number(heures), 0) * this.props.tauxh;

    const resultatArrondi = totalHeures.toFixed(2);

    return +resultatArrondi;
  }

  heureProjet() {
    const totalHeures = this.state.nbrHeures
      .slice(5, 9)
      .reduce((total, heures) => total + Number(heures), 0) * this.props.tauxh;

    const resultatArrondi = totalHeures.toFixed(2);

    return +resultatArrondi;
  }


  calcMontanTotal() {
    const totalHeures = this.state.nbrHeures.reduce((total, heures) => total + Number(heures), 0) * this.props.tauxh
    const resultatArrondi = totalHeures.toFixed(2);

    return +resultatArrondi;
  }


  calcHr1(index) {
    const { nbrHeures } = this.state;
    let heureTotal = 0;

    switch (index) {
      case 0:
        heureTotal = nbrHeures
          .slice(0, 5)
          .reduce((total, heures) => total + Number(heures), 0);
        break;
      case 6:
        heureTotal = nbrHeures
          .slice(5, 10)
          .reduce((total, heures) => total + Number(heures), 0);
        break;
      case 11:
        heureTotal = this.calcHr1(0) + this.calcHr1(6);
        break;
      default:
        break;
    }

    return heureTotal;
  }

  calcHeures() {
    var total = 0;
    for (let i = 0; i < this.state.nbrHeures.length; i++) {
      total += Number(this.state.nbrHeures[i]);
    }
    return total;
  }

  checkValidation() {
    if (this.props.validation) {
      this.setState({ approved: true })
    } else {
      this.handleClick()
    }
  }

  async handleClick() {
    const { dossierValue, nprop } = this.props
    this.setState({
      ht: [this.heureAvantProjet(), this.heureProjet()], approved: false
    });

    const devisTab = {
      nbrHeures: this.state.nbrHeures.map((nbrHeure) => Number(nbrHeure)),
      ht: [this.heureAvantProjet(), this.heureProjet()],
    };

    const json = {
      dureeCon: this.props.duree,
      devisTab,
      totalh: this.calcHeures(),
      totalht: this.calcMontanTotal(),
      ndossier: dossierValue,
      nprop: nprop,
      tauxh: this.props.tauxh,
    };

    this.props.registerView(json);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(json),
    };
    await fetch("/api/devis/registerNewDataCon", requestOptions).catch((err) =>
      console.log(err)
    );

    // await this.props.dispatch(fetchDevis());
    // await this.props.dispatch(newDossierValue(dossierValue));
    await this.props.dispatch(newNpropValue(nprop));
  }

  getValue(index) {
    if (index <= 5) {
      return this.state.nbrHeures[index - 1];
    } else if (index <= 10) {
      return this.state.nbrHeures[index - 2];
    }
  }


  closeDialog() {
    this.setState({ approved: false });
  }

  render() {
    const data = [
      {
        actType: (
          <div className="titleDevisCon2">
            1. Stade Avant-Projet/Permis de construire:
          </div>
        ),
        heures: <div className="titleDevisCon2"></div>,
      },
      {
        actType: "1.1. Ouverture du Registre-Journal de la coordination",
        heures: "",
      },
      {
        actType: "1.2. Visite du site",
        heures: "",
      },
      {
        actType: "1.3. Assistance Déclaration Préalable",
        heures: "",
      },
      {
        actType: "1.4. Examen dossier conception/Analyse de risques",
        heures: "",
      },
      {
        actType: "1.5. Réunions Maîtrise de l'ouvrage/Maîtrise d'OEuvre",
        heures: "",
      },
      {
        actType: <div className="titleDevisCon2">2 . Projet/Consultation:</div>,
        heures: "",
      },
      {
        actType: "2.1. Réunions Maîtrise de l'ouvrage/Maîtrise d'OEuvre",
        heures: "",
      },
      {
        actType: "2.2. Elaboration du P.G.C",
        heures: "",
      },
      {
        actType: "2.3. Elaboration pré D.I.U.O & du D.I.U.O",
        heures: "",
      },
      {
        actType: "2.4. Elaboration du règlement de C.I.S.S.C.T",
        heures: "",
      },
      {
        actType: (
          <div className="titleDevisCon2">TOTAL HEURES PHASE CONCEPTION:</div>
        ),
        heures: "",
      },
    ];
    const columns = [
      {
        Header: "PHASE CONCEPTION",

        columns: [
          {
            Header: "ACTES TYPES",
            accessor: "actType",
          },
          {
            Header: "HEURES",
            accessor: "heures",
            Cell: (props) => {
              if (
                props.row._index === 0 ||
                props.row._index === 6 ||
                props.row._index === 11
              )
                return <strong>{this.calcHr1(props.row._index)}</strong>;
              else
                return (
                  <input
                    className="devisHoursInput"
                    style={{
                      border: "none",
                      height: "100%",
                      width: "100%",
                    }}
                    value={this.getValue(props.row._index)}
                    name={props.column.Header + props.row._index}
                    onChange={(event) =>
                      this.handleChange(event, props.row._index)
                    }
                    onKeyDown={(event) => this.preventNonNumericKeys(event)}
                    inputMode="decimal"
                    pattern="[0-9]*[.,]?[0-9]*"
                    disabled={this.props.validation}
                  />
                );
            },
          },
        ],
      },
    ];

    const data2 = [
      {
        actType: <div>1. Stade Avant-Projet/Permis de construire</div>,
        prix: numberToFormat(this.heureAvantProjet()),
      },
      {
        actType: <div>2. Projet/Consultation</div>,
        prix: numberToFormat(this.heureProjet()),
      },
      {
        actType: (
          <div className="titleDevisCon2">HONORAIRES PHASE CONCEPTION:</div>
        ),
        prix: <strong>{numberToFormat(this.calcMontanTotal())}</strong>,
      },
    ];

    const columns2 = [
      {
        Header: "PHASE CONCEPTION",

        columns: [
          {
            Header: "ACTES TYPES",
            accessor: "actType",
          },
          {
            Header: "PRIX",
            accessor: "prix",
          },
        ],
      },
    ];

    return (
      <div className="devisConTableWrapper">
        <div className="devisTable2">
          <div className="devisTable2Header">Répartition des heures</div>
          <ReactTable data={data} columns={columns} defaultPageSize={12} />

          <div className="devisConSuite">
            <div className="devisTable2Header">Synthèse des honoraires</div>
            <ReactTable data={data2} columns={columns2} defaultPageSize={3} />
          </div>
        </div>
        <div className="devisConSaveButtonWrapper">
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={this.checkValidation.bind(this)}
          >
            Enregistrer
          </Button>
        </div>
        <Dialog open={this.state.approved} onClose={this.closeDialog}>
          <DialogTitle>INFORMATION</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vous ne pouvez pas modifier les heures de la proposition N°{this.props.nprop} déjà validée.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.closeDialog} style={{ color: "white", backgroundColor: "#FF7F50" }}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dossierValue: state.devis.dossierValue,
  deviscon: state.devis.deviscon,
  nprop: state.devis.nprop,
});
export default connect(mapStateToProps)(DevisConTable2);
